'use client';

import React from 'react';

import Image from 'next/image';

import { cn } from '@/lib/utils';

import myImageLoader from './utils';

export type ImageWithCaptionProps = {
    image?: { url?: string; alt?: string };
    caption?: string;
    align?: 'left' | 'center' | 'right';
    float?: boolean;
    className?: string;
};

export const ImageWithCaption: React.FC<ImageWithCaptionProps> = ({
    image,
    caption,
    align = 'center',
    float = false,
    className,
}) => {
    const src = image?.url;
    const alt = image?.alt || '';

    if (!src) return null;

    // Tailwind-классы для float и размеров — можно кастомизировать
    const floatClass =
        align === 'left'
            ? 'float-left mr-4 mb-4' // плавает влево, отступ справа чтобы текст не прилипал
            : align === 'right'
              ? 'float-right ml-4 mb-4' // плавает вправо, отступ слева
              : 'mx-auto my-4'; // при center — центрируем и не плаваем

    // ширину можно регулировать: w-1/3, w-48, max-w-[300px] и т.д.
    const widthClass =
        align === 'center' ? 'w-full max-w-[800px]' : 'w-full sm:w-[250px] md:w-[350px] lg:w-[420px] xl:w-[550px]';

    return (
        // figure остаётся в нормальном потоке (НЕ внутри flex-контейнера)
        <figure
            suppressHydrationWarning
            className={cn(`${float && floatClass} ${widthClass} overflow-visible`, className)}
        >
            {/* Next/Image внутри будет занимать всю ширину figure */}
            <Image
                src={src}
                alt={alt}
                width={500}
                height={500}
                loader={myImageLoader}
                className="block h-auto w-full rounded-md"
            />

            {caption && <figcaption className="text-muted-foreground mt-1 text-left text-sm">{caption}</figcaption>}
        </figure>
    );
};
